import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../Layout';
import LandingHero from '../../presentational/Heros/Landing';
import Features from '../../presentational/Sections/Features';
import Methodology from '../../presentational/Sections/Methodology';
import Clients from '../../presentational/Sections/Clients';
import Testimonials from '../../presentational/Sections/Testimonials';

class App extends Component {
  render() {
    return(
      <Layout mainhero={<LandingHero />} fullHeight>
        <Features />
        <Methodology />
        <Clients />
      </Layout>
    );
  }
};


export default App;
